import { useCheckEmailMutation } from "api/User/hooks.ts";
import { useState } from "react";
import { CheckEmailStatus, RoleEnum } from "types/enums.ts";

export function useTenantCheckEmail(tenantId: string) {
    const [status, setStatus] = useState<CheckEmailStatus | "idle">("idle");
    const [nickname, setNickname] = useState<string | null>(null);
    const [excludedFormFieldIds, setExcludedFormFieldIds] = useState<string[]>([]);

    const checkEmailMutation = useCheckEmailMutation({
        onSuccess: (response) => {
            setStatus(response?.status ?? "idle");
            setNickname(response?.nickname ?? null);
            setExcludedFormFieldIds(Object.values(response?.excluded_form_field_ids ?? {}));
        },
        onError: () => {
            setStatus("idle");
            setNickname(null);
            setExcludedFormFieldIds([]);
        },
    });

    const checkEmail = (email: string, role: RoleEnum) => {
        if (!email) {
            setStatus("idle");
            setNickname(null);
            setExcludedFormFieldIds([]);
            return;
        }
        checkEmailMutation.mutate({ email, tenant_id: tenantId, role });
    };

    const resetStatus = () => {
        setStatus("idle");
        setNickname(null);
        setExcludedFormFieldIds([]);
    };

    return {
        status,
        nickname,
        excludedFormFieldIds,
        isCheckingEmail: checkEmailMutation.isPending,
        checkEmail,
        resetStatus,
    };
}
